type StoryStatusTagColor = { textColor: string; backgroundColor: string };
/**
 * tap / studio에서 사용하는 테마
 */

// main theme
export const tapTheme = {
  color: {
    background: '#f1f1f4',
    main: '#00c3dd',
    black: '#000000',
    white: '#ffffff',
    mainFont: '#131415',
    subfontgray: '#909090',
    labelblack: '#4b4b4b',
    gray: '#d8d8d8',
    gray2: '#696969',
    gray3: '#8A8A8A',
    gray4: '#8A8A8A',
    gray5: '#606064',
    gray6: '#d8d8d8',
    gray7: '#7e7e82',
    text1: '#8A8A8A',
    text2: '#696969',
    text4: '#131415',
    lightgray: '#e7e7e7',
    softgray: '#d9d9d9',
    toggleBtnDisable: '#ececec',
    palegray: '#f1f1f4',
    darkgray: '#bcbcbc',
    blueyGray: '#9899a8',
    brownishGray: '#666666',
    soundEffectHoverGray: '#f3f3f3',
    red: '#fe008a',
    kakaoYellow: '#ffe812',
    facebookBlue: '#396ce9',
    chapterBackground: '#bdd1dc',
    characterLeftBubble: '#b3e5ff',
    characterRightBubble: '#fff0b7',
    chapterEditorGap: '#b3c8d4',
    chapterEditorGapHover: '#a5bdce',
    currentLocationFont: '#606d73',
    tooltipBgColor: '#353d44',
    background1: '#f4f6fA',
    skyBlue: '#bae3ff',
    bookmark: '#dbe0ea',
    bookmark2: '#dbe0ea',
    listItemHover: '#f5f5f6',
    listItemHover2: '#f9f9f9',
    listItemHover3: '#f5f5f6',
    moreMenuBackground: '#fff',
    moreMenuHover: '#f5f5f6',
    popupLine1: '#f1f1f4',
    icon1: '#303037',
    icon2: '#303037',
    icon3: '#eaeaec',
    icon4: '#303037',
    icon5: '#303037',
    grayIcon: '#adb0b8',
    grayIcon2: '#adb0b8',
    tagBackground: '#e6e6e6',
    tagBackground2: '#eaeaec',
    inputBackground: '#eaeaec',
    inputBackground2: '#f1f1f4',
    inputText: '#4b4b4b',
    numLike: '#6B6B6B',
    btnInactive: '#bcbcbc',
    btnInactiveText: '#4b4b4b',
    tagEdit: '#d4d6da',
    narrativeBackground: '#f7f9ff',
    border: '#e3e5e8',
    border2: '#cfcfcf',
    mainBorder: '#ffffff',
    guideText: '#bcbcbc',
    guideText2: '#4c4c4c',
    hover: '#d4d6da',
    hover2: '#abdbfc',
    active2: '#a6dafd',
    panelBackground: '#ffffff',
    track: '#e9e9ea',
    // 라디오 버튼
    button_default: '#D8D8D8',
    button_default_press: '#D4D6DA',
    button_default_disable: '#BCBCBC',

    // 태그 컬러
    tag: {
      // 스토리 상태 태그
      storyStatus: {
        ONGOING: {
          textColor: '#00C3DD',
          backgroundColor: '#F3FDFF',
        },
        COMPLETED: {
          textColor: '#7850C6',
          backgroundColor: '#F6F3FC',
        },
        WAITING: {
          textColor: '#C650B4',
          backgroundColor: '#FDEEFB',
        },
        DRAFT: {
          textColor: '#03C975',
          backgroundColor: '#ECFDF6',
        },
        BLOCKED: {
          textColor: '#131415',
          backgroundColor: '#EEEFF0',
        },
      } as { [key: string]: StoryStatusTagColor },
      // 챕터 상태 태그
      chapterStatus: {
        PUBLISH_REQUESTED: '#7850C6',
        PUBLISHED: '#7BB503',
        UNPUBLISHED: '#FC8A00',
        FREE: '#1C73D8',
      } as { [key: string]: string },
    },
  },
} as const;

export type TapBaseThemeType = typeof tapTheme;
